export default __webpack_public_path__ + "static/media/DSC_5982-min.295d6d5e.JPG";